export const SET_CHAT_ENABLED = 'app/ChatWidget/SET_CHAT_ENABLED';
export const SET_CHAT_DISABLED = 'app/ChatWidget/SET_CHAT_DISABLED';
